import { IUserUIPermissions } from './types';

export const NO_PERMISSIONS: IUserUIPermissions = {
  booking: false,
  home: false,
  managementHome: false,
  allowBookingOverlap: false,
  scheduler: false,
  list: false,
  floorPlan: false,
  map: false,
  collaborators: false,
  meetup: false,
  manageSpaces: false,
  changePassword: false,
  analytics: new Map(),
  week: false,
  navbar: {
    analytics: false,
    home: false,
  },
  spaceTabs: {
    scheduler: false,
    synthesis: false,
  },
};
